import { gql } from '@apollo/client';

export const LIMIT = 20;
export const SKIP = 0;
export const DEBOUNCE_TIME = 700;

export const TAG_HIGHLIGHTS_WITH_TAG_FRAGMENT = gql`
  fragment TagHighlightWithTag on TagHighlight {
    id
    charStart
    charEnd
    entityType
    tag {
      id
      name
      tagType
      tagGroup {
        id
        color
      }
    }
  }
`;

export const TEST_SESSION_FRAGMENT = gql`
  fragment TestSessionFragment on TestSession {
      id
      tester {
        id
        user {
          id
          profile {
            id
            firstName
          }
        }
        project {
          id
          name
          testType
        }
      }
  }
`;

export const TEST_SESSION_NOTE_WITH_TEST_SESSION_FRAGMENT = gql`
fragment TestSessionNotesWithTestSessionFragment on TestSessionNote {
    id
    note
    testSession {
      ...TestSessionFragment
    }
  }
  ${TEST_SESSION_FRAGMENT}
`;

export const GET_PROJECTS_BY_COMPANY = gql`
  query Projects($companyId: ID!) {
    projects(companyId: $companyId) {
      id
      name
    }
  }
`;

export const NOTE_TAG_HIGHLIGHTS_FRAGMENT = gql`
  fragment NoteTagHighlights on TestSessionNote {
    tagHighlights {
      ...TagHighlightWithTag
    }
  }
  ${TAG_HIGHLIGHTS_WITH_TAG_FRAGMENT}
`;

export const ANSWER_TAG_HIGHLIGHTS_FRAGMENT = gql`
  fragment AnswerTagHighlights on TestSessionAnswer {
    tagHighlights {
      ...TagHighlightWithTag
    }
  }
  ${TAG_HIGHLIGHTS_WITH_TAG_FRAGMENT}
`;

export const SPEAKER_TAG_HIGHLIGHTS_FRAGMENT = gql`
  fragment SpeakerTagHighlights on TestSessionSpeaker {
    tagHighlights {
      ...TagHighlightWithTag
    }
  }
  ${TAG_HIGHLIGHTS_WITH_TAG_FRAGMENT}
`;

export const TEST_SESSION_NOTE_FRAGMENT = gql`
  fragment TestSessionNoteFragment on TestSessionNote {
    id
    videoUrl
    status
    note
    createdAt
    videoStartTime
    videoEndTime
    noteType
    testSession {
      ...TestSessionFragment
    }
    createdBy {
      id
      profile {
        id
        firstName
      }
    }
    ...NoteTagHighlights
  }
  ${NOTE_TAG_HIGHLIGHTS_FRAGMENT}
  ${TEST_SESSION_FRAGMENT}
`;

export const REPORT_FRAGMENT = gql`
  fragment ReportFragment on Report {
    id
    name
    rawText
    createdAt
    project {
      id
      name
    }
  }
  ${TEST_SESSION_NOTE_FRAGMENT}
`;

export const TAGHIGHLIGHT_FRAGMENT = gql`
  fragment TagHighlightFragment on TagHighlight {
    id
    createdAt
    ...TagHighlightWithTag
    createdBy {
        id
        profile {
          id
          firstName
      }
    }
    project {
      id
      name
    }
  }
  ${TAG_HIGHLIGHTS_WITH_TAG_FRAGMENT}
`;

export const TEST_SESSION_ANSWER_FRAGMENT = gql`
  fragment TestSessionAnswerFragment on TestSessionAnswer {
    id
    transcriptText
    videoStartTime
    question {
      id
      questionOrder
    }
    createdAt
    testSession {
      ...TestSessionFragment
    }
    ...AnswerTagHighlights
  }
  ${TEST_SESSION_FRAGMENT}
  ${ANSWER_TAG_HIGHLIGHTS_FRAGMENT}
`;

export const TEST_SESSION_SPEAKER_FRAGMENT = gql`
  fragment TestSessionSpeakerFragment on TestSessionSpeaker {
    id
    speakerTag
    createdAt
    text,
    videoStartTime
    testSession {
      ...TestSessionFragment
    }
    ...SpeakerTagHighlights
  }
  ${TEST_SESSION_FRAGMENT}
  ${SPEAKER_TAG_HIGHLIGHTS_FRAGMENT}
`;

export const GET_SEARCH = gql`
  query Search(
    $companyId: ID!,
    $projectIds: [ID!]!,
    $searchableType: [SearchableEnum!]!,
    $search: String,
    $limit: Int,
    $offset: Int,
    $isTranscripts: Boolean!,
    $isNotesAndClips: Boolean!,
    $isReports: Boolean!,
    $isHighlights: Boolean!,
  ) {
    search(
      companyId: $companyId,
      projectIds: $projectIds,
      searchableType: $searchableType,
      search: $search,
      limit: $limit,
      offset: $offset,
    ) {
      id
      companyId
      projectId
      searchableType
      searchHighlights {
        charEnd
        charStart
        text
      }
      searchable {
        ... on TestSessionNote {
          ...TestSessionNoteFragment @include(if: $isNotesAndClips)
        }
        ... on Report {
          ...ReportFragment @include(if: $isReports)
        }
        ... on TagHighlight {
          ...TagHighlightFragment @include(if: $isHighlights)
          entity {
            ... on TestSessionNote {
              ...TestSessionNotesWithTestSessionFragment @include(if: $isHighlights)
            }
            ... on TestSessionAnswer {
              ...TestSessionAnswerFragment @include(if: $isHighlights)
            }
            ... on TestSessionSpeaker {
              ...TestSessionSpeakerFragment @include(if: $isHighlights)
            }
          }
        }
        ... on TestSessionAnswer {
          ...TestSessionAnswerFragment @include(if: $isTranscripts)
        }
        ... on TestSessionSpeaker {
          ...TestSessionSpeakerFragment @include(if: $isTranscripts)
        }

      }
    }
  }
  ${TEST_SESSION_NOTE_FRAGMENT}
  ${REPORT_FRAGMENT}
  ${TAGHIGHLIGHT_FRAGMENT}
  ${TEST_SESSION_NOTE_WITH_TEST_SESSION_FRAGMENT}
  ${TEST_SESSION_ANSWER_FRAGMENT}
  ${TEST_SESSION_SPEAKER_FRAGMENT}
`;
